(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
    const select = document.getElementById("contact-subject");
    const label = document.getElementById("contact-subject-label");

    select.addEventListener("change", function() {
      if (select.value) {
        label.classList.add("active-label");
      } else {
        label.classList.remove("active-label");
      }
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-collection-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
var flkty = new Flickity('.flickity-slider', {
// Flickity options
cellAlign: 'left',
wrapAround: true,
pageDots: false,
lazyLoad: false,
draggable: true,
prevNextButtons: false
});

let sliderButtonLeft = document.querySelector('.slider-arrow-left');
let sliderButtonRight = document.querySelector('.slider-arrow-right');

sliderButtonLeft.addEventListener('click', function() {
flkty.previous();
});
sliderButtonRight.addEventListener('click', function() {
flkty.next();
});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gallery-slider"] && !Shopify.designMode) return;
  try {
    

// Get all elements with the class "collection-card"
var collectionCards = document.querySelectorAll('.collection-card');

// Define a click event handler function
function clickHandler(event) {
  // Find the <img> element within the clicked collection card
  var imgElement = event.target;
  var src = imgElement.getAttribute('src');

  var altText = imgElement.getAttribute('alt');

  var modal = document.querySelector('.modal-container');
  modal.classList.add('open');

  if (modal.classList.contains('open')) {

    var overlay = document.createElement('div');
    overlay.className = 'overlay';

    // Inject the overlay just under the body tag
    document.body.insertBefore(overlay, document.body.firstChild);

    // Inject the imgElement into the modal
    var modalContent = modal.querySelector('.modal-content'); // Assuming the modal has a content area with class 'modal-content'
    modalContent.innerHTML = ''; // Clear any existing content

    var closeButton = document.createElement('button');
    closeButton.className = 'close-modal';
    closeButton.innerHTML = '&times;';

    modalContent.appendChild(closeButton);

    modalContent.appendChild(imgElement.cloneNode(true)); // Clone the imgElement and append it to the modal content

    var captionElement = imgElement.closest('.collection-card').querySelector('.caption-for-image'); // Find the caption associated with the clicked image

  if (captionElement && captionElement.innerHTML.trim() !== '') { // Check if the element exists and innerHTML is not empty
    var captionText = captionElement.innerHTML; // Get the innerHTML contents of the caption element
    var caption = document.createElement('p'); // Create a new p for the caption
    caption.className = 'caption'; // Add a class to the caption p
    caption.innerHTML = captionText; // Set the innerHTML of the caption p to the caption text
    modalContent.appendChild(caption); // Append the caption p to the modal content
  }
    
    document.body.style.overflow = 'hidden';

    setupCloseModalListener();
  }
  
}

// Add a click event listener to each collection card
collectionCards.forEach(function(card) {
  card.addEventListener('click', clickHandler);
});

function setupCloseModalListener() {
  // Find the element with a class of "close-modal"
  var closeModalButton = document.querySelector('.close-modal');
  var modal = document.querySelector('.modal-container');
  var modalContent = modal.querySelector('.modal-content');

  // Add a click event listener to the "close-modal" element
  closeModalButton.addEventListener('click', function () {
    closeModal();
  });

  modalContent.addEventListener('click', function (event) {
    if (!event.target.closest('img')) {
        closeModal();
    }
  });

  function closeModal() {
    var modal = document.querySelector('.modal-container');
    modal.classList.remove('open');
    document.body.style.overflow = 'auto';
    var overlay = document.querySelector('.overlay');
    if(overlay != null) {
      overlay.remove();
    }
  }
}


document.addEventListener('DOMContentLoaded', function() {
  var flkty = new Flickity('.flickity-slider', {
    // Flickity options
    cellAlign: 'left',
    wrapAround: true,
    pageDots: false,
    lazyLoad: false,
    draggable: true,
    prevNextButtons: false
  });

  let sliderButtonLeft = document.querySelector('.slider-arrow-left');
  let sliderButtonRight = document.querySelector('.slider-arrow-right');

  sliderButtonLeft.addEventListener('click', function() {
    flkty.previous(); 
  });
  sliderButtonRight.addEventListener('click', function() {
    flkty.next(); 
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function() {
        let flkty_review = new Flickity('.review-list', {
            cellAlign: 'left',
            wrapAround: false,
            prevNextButtons: false,
            pageDots: false
        });
    
        let reviewButtonLeft = document.querySelector('.review-arrow-left');
    
        let reviewButtonRight = document.querySelector('.review-arrow-right');
    
        let reviewTotalCountSlider = document.querySelector('.review-total-count-slider');

        let reviewTotalCount = document.querySelector('.review-total-count');
    
        let reviewCurrentCount = document.querySelector('.review-current-count');

        let reviewTotalMeta = document.querySelector('.totalReviewsMeta');

        let reviewAverageMeta = document.querySelector('.averageReviewScore');
        
        let totalReviewSlides = flkty_review.slides.length;

        let currentReviewSlide = flkty_review.selectedIndex;
    
        reviewTotalCountSlider.textContent = totalReviewSlides;
        reviewTotalCount.textContent = totalReviewSlides;
        reviewTotalMeta.textContent = totalReviewSlides;

        reviewCurrentCount.textContent = currentReviewSlide + 1;
    
        reviewButtonLeft.addEventListener('click', function() {
          // Change slide when the button is clicked
          if(flkty_review.selectedIndex == 0) {
            reviewCurrentCount.textContent = flkty_review.slides.length;
          } else {
            reviewCurrentCount.textContent = flkty_review.selectedIndex;
          }
          flkty_review.previous(); 
          flkty_review.reloadCells();

        });
    
        reviewButtonRight.addEventListener('click', function() {
          // Change slide when the button is clicked
          flkty_review.next(); 
          reviewCurrentCount.textContent = flkty_review.selectedIndex + 1;
          flkty_review.reloadCells();

        });

        function calculateAverageReviewScore() {
          // Get all divs with data-review-score attribute
          const reviewDivs = document.querySelectorAll('div[data-review-score]');
          
          if (reviewDivs.length === 0) {
              // console.log('No reviews found.');
              return;
          }
          
          // Extract the scores and compute the sum
          let sum = 0;
          reviewDivs.forEach(div => {
              let score = parseFloat(div.getAttribute('data-review-score'));
              sum += score;
          });
          
          // Calculate the average score
          let average = sum / reviewDivs.length;

          return average;
        }

        const averageScore = calculateAverageReviewScore();

        reviewAverageMeta.innerHTML = averageScore;

        let productMetaReviewArea = document.getElementById('product-information__meta--reviews');

        let productMetaReviewContent = document.getElementById('productMetaContent').innerHTML;;

        productMetaReviewArea.innerHTML = productMetaReviewContent;

        productMetaReviewArea.setAttribute('data-meta-review-score', averageScore);

    });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function() {
        let flkty_testimonial = new Flickity('.testimonial-list', {
            cellAlign: 'left',
            wrapAround: true,
            prevNextButtons: false,
            pageDots: false
        });
    
        let testimonialButtonLeft = document.querySelector('.testimonial-arrow-left');
    
        let testimonialButtonRight = document.querySelector('.testimonial-arrow-right');
    
        let testimonialTotalCount = document.querySelector('.testimonial-total-count');
    
        let testimonialCurrentCount = document.querySelector('.testimonial-current-count');
    
        let totalTestimonialSlides = flkty_testimonial.slides.length;

        let currentTestimonialSlide = flkty_testimonial.selectedIndex;
    
        testimonialTotalCount.textContent = totalTestimonialSlides;

        testimonialCurrentCount.textContent = currentTestimonialSlide + 1;
    
        testimonialButtonLeft.addEventListener('click', function() {
          // Change slide when the button is clicked
          if(flkty_testimonial.selectedIndex == 0) {
            testimonialCurrentCount.textContent = flkty_testimonial.slides.length;
          } else {
            testimonialCurrentCount.textContent = flkty_testimonial.selectedIndex;
          }
          flkty_testimonial.previous(); 

        });
    
        testimonialButtonRight.addEventListener('click', function() {
          // Change slide when the button is clicked
          flkty_testimonial.next(); 
          testimonialCurrentCount.textContent = flkty_testimonial.selectedIndex + 1;

        });
    
    });


  } catch(e) { console.error(e); }
})();
})();
